export const toastMsg = {

    loginSuccess: 'Loggedin successfully',
    accountDeActivated: 'Your Account Permissions Are Deactivated',
    loginFailed: 'Failed to login',
    loginInvalid: 'Invalid credentials',
    networkError: 'Network error',

    registerSuccess: 'Registered successfully',
    registerFailed: 'Failed to register',

    videoUpload: 'Uploaded successfully.but it takes some minutes to refresh ',
    failed: 'Failed to get videos',

    //Archive 
    archiveSuccess: 'Archived successfully ',
    archiveFailed: 'Failed to archived this order ',
    deleteArchiveConfirm: 'Are you sure you want to archive this order?',
    ClaimConfirm: 'Are you sure, Do you want to claim this order?',
    ClaimRefuseConfirm: 'Are you sure, Do you want to refuse this claim?',
    deleteArchiveHead: 'Confirm',
    claim: 'Order Claim',
    claimRefuse: 'Claim Refuse',
    deleteArchiveOk: 'Ok',
    deleteArchiveCancel: 'Cancel',
    claimOk: 'claim',
    refuse: 'Refuse',
    claimCancel: 'Cancel',
    //List Archive 
    unArchiveSuccess: 'Un Archived successfully ',
    unArchiveFailed: 'Failed to un archived this order ',
    unArchiveConfirm: 'Are you sure you want to un archive this order?',
    unArchiveHead: 'Confirm to un archive',
    unArchiveOk: 'Ok',
    unArchiveCancel: 'Cancel',

    //Stripe invoice
    invoiceSuccess: 'Invoices created & sent successfully',
    invoiceFailed: 'Failed to create',
    statusUpdated: 'Status updated',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Failed to update',

    dumpFailed: 'failed',
    deleteCategory: 'Deleted successfully',
    deleteCategoryConfirm: 'Are you sure you want to delete?',
    deleteCategoryHead: 'Confirm',
    deleteCategoryOk: 'Confirm',
    deleteCategoryCancel: 'Cancel',

    processSuccess: 'Uploaded completely',
    processFailed: 'failed',
    approvedSuccess: 'Approved succesfully',

    alterSolution: 'You want to change/alter solution?',
    submitLevels: 'Are you sure to submit?',
    alterSolutionHead: 'Confirm',
    afterSubmitLevels: 'Once you submit this order status will be change and show up on the dasboard based roles permission',
    alterSolutionOk: 'Yes',
    alterSolutionCancel: 'No',

    editEmailConfirm: 'Send to additional email along with following ?',
    editEmailHead: 'Confirm',
    editEmailOk: 'Yes',
    editEmailCancel: 'No',
    emailAddSuccess: 'Email added successfully',
    emailAddFailed: 'Failed to add email',

    mailNotifyAboutIdSuccess: 'Mail notify sent to client',
    mailNotifyAboutIdFailed: 'Failed to send email',

    smsNotifyAboutIdSuccess: 'SMS notify sent to client',
    smsNotifyAboutIdFailed: 'Failed to send sms',

    saveEstimateSolution: "Estimated solution saved successfully",
    afterReview: 'Saved successfully',
    failedReview: 'Failed to save',
    failedReviewSome: 'Failed to save some rows only',
    warningBeforeReview: 'Please select category from checkbox',
    warningForAddSubCate: 'Please select category from checkbox to add more sub category',
    warningForitemNumber: 'Please give item numbers to all rows',
    warningForCategory: 'Please select category to all rows',
    addSubCategory: 'Added sub category',
    warningNoSubCate: 'Please give any input before submit',

    noDocumentUploaded: 'No document Uploaded',
    noPictureUploaded: 'No pre-list details found',
    delConfirm: 'Are you sure you want to delete?',

    jobAssigned: 'Job assigned successfully',
    jobConfirm: 'Are you sure you want to assign this user ?',
    jobHead: 'Confirm',
    jobOk: 'Confirm',
    jobCancel: 'Cancel',

    notEstablished: 'Not yet added',
    noReceipt: 'No recepit available',

    //Calendar
    editSuccess: 'Updated successfully',
    editFailed: 'Failed to update',
    noUserToSendMail: 'User not found to send mail',
    updateFailOnStatusChange: 'Update failed while status change',
    fillAllvalues: 'Please fill all values',

    deleteScheSuccess: 'Deleted successfully',
    deleteScheFailed: 'Failed to Delete',

    //Contact
    userEditSuccess: 'Updated successfully',
    userEditFailed: 'Failed to update',
    userDeleteSuccess: 'Deleted successfully',
    userDeleteFailed: 'Failed to Delete',

    // usedMorethanOne file
    mailSent: 'Mail sent successfully',
    mailNotSent: 'Mail not sent',

    //Company serve
    uploadCompanyLogoSuccess: 'uploaded successfully',
    uploadCompanyLogoFailed: 'Failed to upload logo',

    //Solutions description
    uploadSolutionDescriptionSuccess: 'Solution estimate added to database successfully',
    uploadSolutionDescriptionFailed: 'Failed to Add Solution',
    uploadSolutionDescriptionExisted: 'This solution description is already existed',
    changingCostOptionWarning: 'Changing cost operation will reset current cost value',
    changingPrimaryOptionWarning: 'Changing Primary Category Option will reset current Primary Category value',

    //Drop Down Status 
    statusChange: "Status Changed Failed",
    statusChangeSuccess: "Status Updated Success",

    //Cancel Work Request 
    cancelWorkRequest: "Work Request Cancelled Successfully ,Now Can Alter Solution Estimate",
    cancelWorkRequestFailed: "Work Request Cancel Not Update",
    cancelWorkRequestUpdate: "Work Request Cancel Update Failed",
    agentSubmissionFailed: "Original Agent Submission Display Failed",
    openHomeInspectionFailed: "Open Home Inspection Failed",
    cancelWorkRequestMessage: 'Are you sure ,you want to Close Project?',

    //Close Project
    closeProjectSuccess: 'Project Closed Successfully',
    closeProjectFiled: 'Project Closd Failed',
    closeProjecttMessage: 'Are you sure ,you want to Close Project?',
    alreadyClosed: 'Project Already Closed',

    //after approve solution 
    afterApproveSolution: 'After approved solution cannot edit and delete . You can click alter an edit',

    //Pro Job Details 
    noSuppliesMaterialList: ' No Shopping Material List',
    noShoppingMaterialList: 'No Supplies Material List',
    noUploadPicsList: 'No Uploaded Pictures',
    noQuoteImageList: 'No Quote Images',
    noSignImageList: 'No Sign Image',

    claimOrderSuccess: "You claimed this order successfully",
    claimOrderFailed: "You claimed this order Failed",
    alreadyclaimed: "This order already claimed by ",
    claimOrderRefused: "Refused to claim for this order success",
    claimOrderRefusedFailed: "Refused to claim for this order failed",

    accountOwnerAccess: "In Account Owner Information Only can edit by account owner",
    accountOwnerDelAccess: "You cannot delete account owner",

    areYouSureAsExec: "Are you sure?",
    makeExec: 'Once you change as executive then user will have all permission execpt remove the account owner.',

    makeExecSuccess: "User convert to executive successfully",
    makeExecFailed: "User convert to executive failed",

    limitChange: "Limit Change",
    limitOk: 'Yes',
    limitCancel: 'No',
    estimateNotPrepared: "Solution Estimate Not Prepared",


    // New resend quote messages
    resendQuoteConfirm: 'Are you sure you want to resend the quote to the client? This will send the same approved solution estimate again.',
    resendQuoteHead: 'Resend Quote',
    resendQuoteOk: 'Resend',
    resendQuoteCancel: 'Cancel',
    quoteResendSuccess: 'Quote has been successfully resent to the client',
    quoteResendFailed: 'Failed to resend quote. Please try again.',
    noApprovedSolutionsToResend: 'No approved solutions available to resend',
    solutionsNotApproved: 'Solutions must be approved before they can be resent',
    smsResendSuccess: 'SMS notification sent successfully',
    smsResendFailed: 'Failed to send SMS notification',

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/toastValues.ts